
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ZhTW from 'date-format-parse/lib/locale/zh-tw';
import { CreditTypeInput, CreditTypeOutput } from "@fubonlife/tacallindiy-core-axios-sdk";

interface CreditInfo {
	originCardNum?: string,
	expiryDate?:string,
	errorMsg?: string,
	idNo?: string
}

@Component
export default class UpdateCreditCard extends Vue {

	public adFormatter = this.$adDateTimeLocale
	dateLang = {
		formatLocale: ZhTW,
		yearFormat: (year) => {
			return `${year} 年`;
		},
		monthFormat: 'MMM',
		monthBeforeYear: false,
	}


	@Prop()
	info: CreditInfo

	@Prop()
	submitDisabled: boolean

	cardType = null;

	form = {
		cardNumber: '',
		effectiveDate: '',
	}

	numberMask = '';

	validStatus: { [key: string]: string } = {
		cardNumber: '',
		effectiveDate: ''
	}

	customErrorMsg: { [key: string]: string } = {
		cardNumber: '',
		effectiveDate: ''
	}

	created() {
		console.log("info", this.info);

	}

	@Watch('form.cardNumber')
	cardNumberChange() {
		this.$nextTick(() => {
			this.numberMask = '####-####-####-####';
		})
		this.creditCardType(this.form.cardNumber);
	}

	// 遮蔽身分證
	get maskedCustId() {
		return this.info.idNo.replace(/(.{5}).*(.{3})/, '$1**$2');
	}

	// 信用卡logo
	get getCreditCardType() {
		return 'logo-' + this.cardType;
	}

	// 取得信用卡卡別
	creditCardType(number: string) {
		let cardNum = number.replaceAll('-', '');
		const creditNum: CreditTypeInput = {
			cardNum: cardNum
		}
		if (cardNum.length !== 16) {
			this.cardType = null;
		} else {
			this.$CommonControllerApi.getCreditTypeUsingPOST1(creditNum)
				.then(res => {
					if (res.status === 200) {
						let result: CreditTypeOutput = JSON.parse(JSON.stringify(res.data));
						if (result.processStatus.status === 'SUCCESS') {
							this.cardType = result.type
						}
					}
				})
		}
	}

	// 效期範圍
	disabledDate(current) {
		let date = new Date()
		date.setMonth(date.getMonth() + 1);
		return current < date;
	}

	// 手動觸發 antd FormModel 驗證
	triggerValidate(field: string, msg?: string) {
		if (msg) {
			this.validStatus[field] = "error";
			this.customErrorMsg[field] = msg;
		} else {
			this.validStatus[field] = "success";
			this.customErrorMsg[field] = "";
		}
	}

	// 前端檢核規則-必填
	checkRquired(value: string, requiredName: string) {
		if (!value) {
			return requiredName + "欄位不可為空值。";
		}
	}

	// 前端檢核規則-信用卡
	checkCreditCardNumber(value: string) {
		if (!value) {
			return "信用卡號碼欄位不可為空值。";
		}
		if (value.length !== 19) {
			return "請輸入完整信用卡號碼。";
		}
	}

	// 送出
	handleBeforeSubmit() {
		// 先檢核必填再檢核授權 失敗>修改最上方卡號跟錯誤訊息
		// 成功則儲存卡號 + 回傳加密的卡號跟開卡行給父元件
		console.log(this.form);
		const cardNumberHasError = this.checkCreditCardNumber(this.form.cardNumber);
		const cardDateHasError = this.checkRquired(this.form.effectiveDate, '有效年月');
		if (!cardNumberHasError && !cardDateHasError) {
			console.log('valid credit', this.form);
			const validInput = JSON.parse(JSON.stringify(this.form));
			this.$emit('afterUpdateCredit', validInput);
		} else {
			this.triggerValidate("cardNumber", cardNumberHasError);
			this.triggerValidate("effectiveDate", cardDateHasError);
		}
	}

	clearForm() {
		this.form.cardNumber = '';
		this.form.effectiveDate = '';
	}

	// 取消
	handleCancel() {
		this.$emit('cancelUpdateCredit');
	}

}
